import { SelectionModel } from '@angular/cdk/collections';
import { AsyncPipe, NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyTableModule } from '@angular/material/legacy-table';
import { ClientMaterialService } from '@cutting/main/shared/services/client-material.service';
import { CuttingClientMaterial, OverlayLoaderModule, StandardCuttingSizes } from 'cloud-shared-lib';
import _ from 'lodash';
import { map, share, startWith } from 'rxjs';

@Component({
  selector: 'cutting-material-standard-sizes-dialog',
  templateUrl: 'material-standard-sizes-dialog.component.html',
  standalone: true,
  imports: [
    MatIconModule,
    MatDialogModule,
    MatLegacyButtonModule,
    MatLegacyCheckboxModule,
    MatLegacyTableModule,
    NgIf,
    AsyncPipe,
    OverlayLoaderModule,
  ],
})
export class MaterialStandardSizesDialogComponent {
  displayedColumns: string[] = ['select', 'length', 'width'];
  selection = new SelectionModel<StandardCuttingSizes>(false, []);

  data$ = this.clientMaterialService
    .getStandardCuttingsSizes(
      this.data.material.name,
      this.data.material.article,
      this.data.material.type,
      this.data.orderId
    )
    .pipe(share());

  loading$ = this.data$.pipe(
    startWith(true),
    map(s => _.isEmpty(s))
  );

  constructor(
    private clientMaterialService: ClientMaterialService,
    @Inject(MAT_DIALOG_DATA) private data: { orderId?: number; material: CuttingClientMaterial }
  ) {}
}
